import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_sandwich",
  "use": "svg_sandwich-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"svg_sandwich\"><path d=\"M0 12h18v-2H0v2Zm0-5h18V5H0v2Zm0-7v2h18V0H0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol